import 'core-js/modules/es6.regexp.to-string';
import 'core-js/modules/es6.reflect.construct';
import _classCallCheck from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck';
import _createClass from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/createClass';
import _inherits from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/inherits';
import _possibleConstructorReturn from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '/var/www/html/_limesurvey/assets/packages/questioneditor/node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf';
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === 'undefined' || !Reflect.construct)
        return false;
    if (Reflect.construct.sham)
        return false;
    if (typeof Proxy === 'function')
        return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {
        }));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/editorui/boxed/boxededitoruiview
 */
import EditorUIView from '../../editorui/editoruiview';
import LabelView from '../../label/labelview';
import uid from '@ckeditor/ckeditor5-utils/src/uid';
/**
 * The boxed editor UI view class. This class represents an editor interface
 * consisting of a toolbar and an editable area, enclosed within a box.
 *
 * @extends module:ui/editorui/editoruiview~EditorUIView
 */
var BoxedEditorUIView = /*#__PURE__*/
function (_EditorUIView) {
    _inherits(BoxedEditorUIView, _EditorUIView);
    var _super = _createSuper(BoxedEditorUIView);
    /**
   * Creates an instance of the boxed editor UI view class.
   *
   * @param {module:utils/locale~Locale} locale The locale instance..
   */
    function BoxedEditorUIView(locale) {
        var _this;
        _classCallCheck(this, BoxedEditorUIView);
        _this = _super.call(this, locale);
        var ariaLabelUid = uid();
        /**
     * Collection of the child views located in the top (`.ck-editor__top`)
     * area of the UI.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */
        _this.top = _this.createCollection();
        /**
     * Collection of the child views located in the main (`.ck-editor__main`)
     * area of the UI.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */
        _this.main = _this.createCollection();
        /**
     * Voice label of the UI.
     *
     * @protected
     * @readonly
     * @member {module:ui/view~View} #_voiceLabelView
     */
        _this._voiceLabelView = _this._createVoiceLabel(ariaLabelUid);
        _this.setTemplate({
            tag: 'div',
            attributes: {
                class: [
                    'ck',
                    'ck-reset',
                    'ck-editor',
                    'ck-rounded-corners'
                ],
                role: 'application',
                dir: locale.uiLanguageDirection,
                lang: locale.uiLanguage,
                'aria-labelledby': 'ck-editor__aria-label_'.concat(ariaLabelUid)
            },
            children: [
                _this._voiceLabelView,
                {
                    tag: 'div',
                    attributes: {
                        class: [
                            'ck',
                            'ck-editor__top',
                            'ck-reset_all'
                        ],
                        role: 'presentation'
                    },
                    children: _this.top
                },
                {
                    tag: 'div',
                    attributes: {
                        class: [
                            'ck',
                            'ck-editor__main'
                        ],
                        role: 'presentation'
                    },
                    children: _this.main
                }
            ]
        });
        return _this;
    }
    /**
   * Creates a voice label view instance.
   *
   * @private
   * @returns {module:ui/label/labelview~LabelView}
   */
    _createClass(BoxedEditorUIView, [{
            key: '_createVoiceLabel',
            value: function _createVoiceLabel(ariaLabelUid) {
                var t = this.t;
                var voiceLabel = new LabelView();
                voiceLabel.text = t('Rich Text Editor');
                voiceLabel.extendTemplate({
                    attributes: {
                        id: 'ck-editor__aria-label_'.concat(ariaLabelUid),
                        class: 'ck-voice-label'
                    }
                });
                return voiceLabel;
            }
        }]);
    return BoxedEditorUIView;
}(EditorUIView);
export {
    BoxedEditorUIView as default
};